export const ndviColorRange = (value: number): number => parseInt((value * 10).toFixed(0))
